import { render, staticRenderFns } from "./featureEdit.vue?vue&type=template&id=0d2c283f&"
import script from "./featureEdit.vue?vue&type=script&lang=js&"
export * from "./featureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports